<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="海报配置" @back="goBack" /></span>
        </div>
        <el-form>
          <el-form-item label-width="120px" label="转跳位置:" prop="username">
            <el-select v-model="formData.position" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
        <el-button v-permisaction="['config:RewardSuperBombEdit:save']" :disabled="isOnline === 1" type="primary" @click="onSubmit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  getActivtyList,
  getActivtyStageRewardCfg, updateActivtyRewardConfData,
  updateActivtyStageRewardCfg
} from '@/api/config/activity-cfg'

export default {
  name: 'RewardPosterEdit',
  data() {
    return {
      isOnline: 0,
      aid: 0,
      type: '',
      defaultData: {
        position: 1
      },
      formData: {},
      options: [
        { value: 1, label: '棋盘主界面' },
        { value: 2, label: '建造界面' },
        { value: 3, label: '雇佣界面' },
        { value: 4, label: '卡片系统界面' },
        { value: 5, label: '团队界面' },
        { value: 6, label: '回归界面' }
      ]
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.type = this.$route.query.type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getTables()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    onSubmit() {
      updateActivtyRewardConfData({ name: this.aid, data: JSON.stringify(this.formData) }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.formData = []
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list[0].reward_conf
          if (!this.formData) {
            this.formData = this.defaultData
          }
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
